// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"footer_footerContainer__3FR_i","footerInfo":"footer_footerInfo__1o0V1","copy":"footer_copy__2_NRg"};